module.exports = __webpack_public_path__ + "img/mont-desk-recortada.c66b0ff9.svg";